import React, { createContext, useContext, useState } from 'react';

const DnDContext = createContext([null, () => {}]);

export const DnDProvider = ({ children }) => {
  const [type, setType] = useState(null);
  const [nodeData, setNodeData] = useState(null);

  return (
    <DnDContext.Provider value={[type, setType, nodeData, setNodeData]}>
      {children}
    </DnDContext.Provider>
  );
};

export const useDnD = () => {
  return useContext(DnDContext);
};
